import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthLayout from '../../Components/AuthLayout';
import { getProducts } from '../../Services/subscription';
import { findPlanProduct } from '../../Utils/planUtils';
import uatQRCode from '../../Assets/icon/uat-aris-app-code.png';
import './style.css';

const QRCodePage = () => {
  const [searchParams] = useSearchParams();
  const [planInfo, setPlanInfo] = useState(null);
  
  const planName = searchParams.get('plan');
  const subscriptionMode = searchParams.get('subscription_mode');

  useEffect(() => {
    if (planName && subscriptionMode) {
      fetchPlanInfo();
    }
  }, [planName, subscriptionMode]);

  const fetchPlanInfo = async () => {
    try {
      const response = await getProducts();
      if (response?.payload?.products) {
        const planData = findPlanProduct(response.payload.products, planName, subscriptionMode);
        
        if (planData) {
          setPlanInfo({
            name: planData.displayName,
            price: planData.price,
            interval: planData.interval
          });
        }
      }
    } catch (err) {
      console.error('Error fetching plan info:', err);
    }
  };

  const getQRCodeImage = () => {
    // Check if we're in production environment
    const isProduction = process.env.REACT_APP_ENV === 'production' || 
                        process.env.NODE_ENV === 'production';
    
    // For production, use environment variable or fallback to API-generated QR
    if (isProduction && process.env.REACT_APP_PROD_QR_CODE) {
      return process.env.REACT_APP_PROD_QR_CODE;
    }
    
    // For UAT/development, use local QR code image
    return uatQRCode;
  };

  return (
    <AuthLayout>
      <div className="qr-page-content">
        {planInfo && (
          <p className="auth-plan-info">
            You're getting: {planInfo.name} - ${planInfo.price}/{planInfo.interval === 'yearly' ? 'year' : 'month'}
          </p>
        )}
        
        <h2 className="auth-title">Continue on your phone</h2>
        <p className="auth-subtitle">
          Aris begins with a short exercise in the mobile app.<br />
          Complete it once, and you'll have full access here on the web.
        </p>

        <div className="qr-code-container">
          <img 
            src={getQRCodeImage()} 
            alt="QR Code" 
            className="qr-code-image"
          />
        </div>

        <p className="qr-scan-instruction">
          Scan with your phone to open the Aris app and continue
        </p>
      </div>
    </AuthLayout>
  );
};

export default QRCodePage;
